import { createSlice } from "@reduxjs/toolkit";

export const redeemPointsSlice = createSlice({
  name: "redeem-points",
  initialState: {
    isLoading: false,
    isError: false,
    redeemPointsData: [],
    message: "",
  },
  reducers: {
    onPostRedeemPoints: (state) => {
      return {
        ...state,
        isPostLoading: true,
        redeemPointsData: [],
        postmessage: "",
      };
    },

    onPostRedeemPointsSuccess: (state, { payload }) => {
      const { data = [], message = "", status_code = 200 } = payload;
      return {
        ...state,
        isPostLoading: false,
        redeemPointsData: data,
        postmessage:message,
        post_status_code:status_code,
      };
    },

    onPostRedeemPointsError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        redeemPointsData: data,
        postmessage:message,
        post_status_code:status_code,
        isPostLoading: false,
      };
    },
    onPostRedeemPointsReset: (state) => {

      return {
        ...state,
        post_status_code:null,
        isPostLoading: false,
      };
    },
  },
});

export const {
  onPostRedeemPoints,
  onPostRedeemPointsSuccess,
  onPostRedeemPointsError,
  onPostRedeemPointsReset
} = redeemPointsSlice.actions;

export default redeemPointsSlice.reducer;
